import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Company.css';

const Company = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="main-hero demo-hero">
        <div className="hero-gif-fade-left"></div>
        <div className="hero-gif-fade-right"></div>
        <h1 className="hero-page-title">Company</h1>
      </section>

      <section className="co-content">
        <div className="co-layout">
          <h2 className="co-heading">Securing the Future of Enterprise AI</h2>
          <p className="co-description">
            Bltz AI builds the security and governance infrastructure that enterprises need to deploy AI with confidence. Our platform provides real-time visibility, threat detection, policy enforcement, and compliance automation — enabling organizations to adopt AI at scale without compromising on security.
          </p>

          <div className="co-grid">
            <div className="co-card">
              <h3 className="co-card-title">Our Mission</h3>
              <p className="co-card-text">
                To make enterprise AI adoption safe, governed, and compliant. We believe that AI security should be a competitive advantage — not a barrier to innovation. Bltz gives security teams the tools to protect their organizations without slowing down AI-driven transformation.
              </p>
            </div>
            <div className="co-card">
              <h3 className="co-card-title">What We Do</h3>
              <p className="co-card-text">
                Our platform discovers every AI system across your organization, enforces governance policies in real time, continuously tests defenses with purple team AI agents, and automates compliance reporting for ISO 42001, NIST AI RMF, SOC 2, and the EU AI Act.
              </p>
            </div>
            <div className="co-card">
              <h3 className="co-card-title">Who We Serve</h3>
              <p className="co-card-text">
                CISOs, security teams, and GRC leaders at enterprises navigating the complexities of AI adoption. Our customers include Fortune 500 financial institutions, healthcare systems, technology companies, and government agencies.
              </p>
            </div>
            <div className="co-card">
              <h3 className="co-card-title">Our Approach</h3>
              <p className="co-card-text">
                We combine deep AI security research with operational pragmatism. Our team brings experience from leading cybersecurity organizations, AI research labs, and enterprise security operations — building products that work in the real world, not just in demos.
              </p>
            </div>
          </div>

          <div className="co-cta">
            <button className="co-cta-btn" onClick={() => { navigate('/book-demo'); window.scrollTo(0, 0); }}>
              Book a Demo &rarr;
            </button>
          </div>

          <span className="co-back-link" onClick={() => { navigate('/'); window.scrollTo(0, 0); }} style={{ cursor: 'pointer' }}>
            ← Back to Home
          </span>
        </div>
      </section>
    </>
  );
};

export default Company;
